var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"thousands"},[(_vm.prefix)?_c('span',{staticClass:"prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }